// "Name (phone)" — or the email when there's no phone — so customers who share a
// name can be told apart in pickers.
const customerLabel = (customer) => {
  const contact = customer.phone || customer.email;
  return contact ? `${customer.name} (${contact})` : customer.name;
};

export default customerLabel;
